module.exports = __webpack_public_path__ + "img/1.c54bb36.svg";